"use strict";var e=require("@apollo/client"),t=require("./CategoryModel-cjs-D7VALxvO.js"),o=e.gql`
  mutation checkout(
    $cartId: ID!
    $paymentObject: PaymentObject
    $deliverySlot: SlotObject
    $loyaltyPlan: Boolean
  ) {
    checkout(
      cartId: $cartId
      paymentObject: $paymentObject
      deliverySlot: $deliverySlot
      loyaltyPlan: $loyaltyPlan
    ) {
      status
      jobNumber
      jobId
      url
    }
  }
`,r=e.gql`
  query GetCategories($storeId: ID!) {
    getCategoriesByStore(storeId: $storeId) {
      id
      name
      countProducts
      image
    }
  }
`,a=e.gql`
  query GetJobId($jobNumber: String!) {
    getJobByJobNumber(jobNumber: $jobNumber) {
      jobId
    }
  }
`,d=e.gql`
  query GetShopsByAddress($addressId: ID!, $operationalModel: OperationModel!) {
    getStoresNearbyByAddress(
      addressId: $addressId
      operationalModel: $operationalModel
    ) {
      phone
      id
      name
      code
      state
      cities {
        name
      }
      address
      country
      operationModel
      serviceFee {
        PICK_AND_COLLECT
        DELIVERY
      }
    }
  }
`,s=e.gql`
  fragment BaseProduct on Product {
    boost
    brand
    categories {
      name
      id
      categoriesTree {
        name
        id
      }
    }
    categoriesPath
    clickMultiplier
    description
    ean
    formats {
      equivalence
      format
      maxQty
      minQty
      unitEquivalence
    }
    id
    isActive
    isAvailable
    maxQty
    minQty
    name
    nutritionalDetails
    photosUrls
    price
    promotion {
      conditions
      description
      isActive
      type
    }
    showSubUnit
    sku
    slug
    specialMaxQty
    specialPrice
    stock
    subQty
    subUnit
    tags {
      id
      tagReference
      name
      filter
      enabled
      description
      backgroundColor
      textColor
    }
    unit
    variants {
      productModifications
      selectors
    }
  }
`,n=e.gql`
  ${s}
  fragment ProductsInCart on CartProduct {
    id
    quantity
    instruction
    format
    subtotal
    discounts
    params
    isAvailable
    price
    variantId
    variant
    product {
      ...BaseProduct
    }
  }
`,i=e.gql`
  ${n}
  mutation createCart(
    $customerId: ID!
    $storeId: ID!
    $operationalModel: OperationModel!
  ) {
    createCart(
      customerId: $customerId
      storeId: $storeId
      operationalModel: $operationalModel
    ) {
      id
      coupon {
        couponCode
        benefit
      }
      customer {
        id
        name
      }
      store {
        id
        name
      }
      operationalModel
      products {
        ...ProductsInCart
      }
      paymentSummary {
        subtotal
        shipping
        discounts {
          coupon {
            code
            discountOnTotal
            discountOnShipping
            items
          }
          products {
            discountOnSubtotal
          }
        }
        taxes
        total
      }
      cartParams {
        minimumOrder
        maximumOrder
        freeDelivery
        serviceFee
      }
    }
  }
`,l=e.gql`
  query GetCategory($id: ID!, $storeId: ID!) {
    getCategory(id: $id, storeId: $storeId) {
      id
      name
      parentId
      image
      slug
      redirectTo
      store {
        id
      }
      subCategories(includeOthers: false) {
        name
        id
        image
        parentId
        slug
        redirectTo
      }
      banners {
        id
        title
        desktopImage
        mobileImage
        targetCategory
        targetUrl {
          url
          type
        }
      }
      categoriesTree {
        id
        name
        parentId
        slug
        redirectTo
      }
    }
  }
`,g=e.gql`
  query GetDrawerCategories($id: ID!, $storeId: ID!) {
    getCategory(id: $id, storeId: $storeId) {
      id
      slug
      redirectTo
      name
      parentId
      categoriesTree {
        id
        slug
        redirectTo
        name
        parentId
      }
      subCategories(includeOthers: false) {
        id
        name
        slug
        redirectTo
        parentId
        subCategories(includeOthers: false) {
          id
        }
      }
    }
  }
`,u=e.gql`
  query GetStore($storeId: ID, $clientId: String) {
    getStore(storeId: $storeId, clientId: $clientId) {
      id
      code
      state
      cities {
        name
      }
    }
  }
`,c=e.gql`
  query GetDrawerSubcategories($id: ID!, $storeId: ID!) {
    getCategory(id: $id, storeId: $storeId) {
      id
      slug
      redirectTo
      name
      parentId
      subCategories(includeOthers: false) {
        id
        slug
        redirectTo
        name
        parentId
        subCategories(includeOthers: false) {
          id
        }
      }
    }
  }
`,p=e.gql`
  query GetJobId($jobNumber: String!) {
    getJobByJobNumber(jobNumber: $jobNumber) {
      jobId
      operationalModel
    }
  }
`,I=e.gql`
  query GetStore($storeId: ID, $clientId: String) {
    getStore(storeId: $storeId, clientId: $clientId) {
      dynamicParams
      id
      name
      code
      state
      cities {
        name
      }
    }
  }
`,m=e.gql`
  query GetStoresNearbyByAddress(
    $addressId: ID!
    $operationalModel: OperationModel
    $clientId: String!
    $storeReferences: [String!]
  ) {
    getStoresNearbyByAddress(
      addressId: $addressId
      operationalModel: $operationalModel
      clientId: $clientId
      storeReferences: $storeReferences
    ) {
      dynamicParams
      phone
      id
      name
      code
      state
      cities {
        name
      }
      address
      country
      operationModel
      serviceFee {
        PICK_AND_COLLECT
        DELIVERY
      }
      usedIfNotCoverage
    }
  }
`,y=e.gql`
  query GetStoresNearbyByCoords(
    $clientId: String!
    $operationalModel: OperationModel!
    $coordinates: Coords!
  ) {
    getStoresNearbyByCoords(
      clientId: $clientId
      operationalModel: $operationalModel
      coordinates: $coordinates
    ) {
      id
      name
      code
      phone
      state
      cities {
        name
      }
      address
      country
      dynamicParams
      operationModel
      serviceFee {
        PICK_AND_COLLECT
        DELIVERY
      }
      usedIfNotCoverage
    }
  }
`,$=e.gql`
  query getCategoryBasic(
    $getProductsByCategoryInput: GetProductsByCategoryInput!
  ) {
    getProductsByCategory(
      getProductsByCategoryInput: $getProductsByCategoryInput
    ) {
      pagination {
        page
      }
      category {
        reference
        slug
      }
    }
  }
`,C=e.gql`
  fragment AggregateBucketModel on AggregateBucketModel {
    min
    max
    key
    docCount
  }
`,b=e.gql`
  ${C}
  fragment AggregateModel on AggregateModel {
    name
    docCount
    buckets {
      ...AggregateBucketModel
    }
  }
`,P=e.gql`
  fragment BannerModel on BannerModel {
    id
    storeId
    title
    desktopImage
    mobileImage
    targetUrl
    targetUrlInfo {
      type
      url
    }
    targetCategory
    index
    categoryId
  }
`,M=e.gql`
  fragment CarouselModel on CarouselModel {
    id
    name
    autoplaySpeed
    lazyLoading
    isActive
    createdAt
    updatedAt
    banners {
      id
      name
      webImageUrl
      tabletImageUrl
      appImageUrl
      redirectUrl
      redirectMode
      isActive
    }
    position
  }
`,q=e.gql`
  fragment CatalogProductModelSimple on CatalogProductModel {
    name
    photosUrl
    sku
    ean
    isActive
    slug
    isAvailable
    seals
  }
`,S=e.gql`
  ${t.C}
  fragment CategoryWithProductsModel on CategoryWithProductsModel {
    name
    reference
    level
    path
    hasChildren
    active
    boost
    isAvailableInHome
    slug
    photoUrl
    categoryNamesPath
    imageUrl
    shortName
    isFeatured
    products {
      ...CatalogProductModel
    }
    hasAgeRestriction
  }
`,h=e.gql`
  fragment PaginationTotalModel on PaginationTotalModel {
    value
    relation
  }
`,f=e.gql`
  ${h}
  fragment PaginationModel on PaginationModel {
    page
    pages
    total {
      ...PaginationTotalModel
    }
  }
`,B=e.gql`
  ${t.a}
  query GetCategoryTree($getCategoryInput: GetCategoryInput!) {
    getCategory(getCategoryInput: $getCategoryInput) {
      ...CategoryModel
    }
  }
`,x=e.gql`
  ${t.C}
  ${S}
  ${P}
  query GetHome($getHomeInput: GetHomeInput!) {
    getHome(getHomeInput: $getHomeInput) {
      banners {
        ...BannerModel
      }
      categories {
        ...CategoryWithProductsModel
      }
      store {
        dynamicParams
        id
        name
        reference
      }
    }
  }
`,v=e.gql`
  ${S}
  ${f}
  ${b}
  ${P}
  ${t.P}
  ${M}
  query GetProductsByCategory(
    $getProductsByCategoryInput: GetProductsByCategoryInput!
  ) {
    getProductsByCategory(
      getProductsByCategoryInput: $getProductsByCategoryInput
    ) {
      category {
        ...CategoryWithProductsModel
      }
      pagination {
        ...PaginationModel
      }
      aggregates {
        ...AggregateModel
      }
      carousels {
        ...CarouselModel
      }
      banners {
        ...BannerModel
      }
      promoted {
        ...PromotedModel
      }
    }
  }
`,A=e.gql`
  ${q}
  query GetSearchSuggestion(
    $getSearchSuggestionInput: GetSearchSuggestionInput!
  ) {
    getSearchSuggestion(getSearchSuggestionInput: $getSearchSuggestionInput) {
      ...CatalogProductModelSimple
    }
  }
`,D=e.gql`
  query GetStoreConfigurations(
    $storeConfigurationsInput: StoreConfigurationsInput!
  ) {
    getStoreConfigurations(
      storeConfigurationsInput: $storeConfigurationsInput
    ) {
      allowSubstituteProducts
      enableDynamicHome
      enforceCustomerPhoneValidation
    }
  }
`,O=e.gql`
  ${t.C}
  query ReplaceableProducts($searchProductsInput: SearchProductsInput!) {
    searchProducts(searchProductsInput: $searchProductsInput) {
      products {
        ...CatalogProductModel
      }
    }
  }
`,G=e.gql`
  ${t.C}
  ${f}
  ${b}
  ${t.P}
  ${M}
  query SearchProducts($searchProductsInput: SearchProductsInput!) {
    searchProducts(searchProductsInput: $searchProductsInput) {
      products {
        ...CatalogProductModel
      }
      pagination {
        ...PaginationModel
      }
      aggregates {
        ...AggregateModel
      }
      promoted {
        ...PromotedModel
      }
      carousels {
        ...CarouselModel
      }
    }
  }
`;exports.a=i,exports.b=l,exports.c=o,exports.d=$,exports.e=B,exports.f=g,exports.g=r,exports.h=u,exports.i=c,exports.j=x,exports.k=a,exports.l=p,exports.m=v,exports.n=A,exports.o=d,exports.p=I,exports.q=D,exports.r=m,exports.s=y,exports.t=O,exports.u=G;